import * as React from "react";
import { Formik, Form, Field } from "formik";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import DatePicker from "@mui/lab/DatePicker";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

// styles
import styles from "./FilterBox.module.scss";

// icons
import DoneAllIcon from "@material-ui/icons/DoneAll";
import FilterListIcon from "@material-ui/icons/FilterList";
import { Button } from "@mui/material";

interface IProps {
  toggle: () => void;
  handleFiltering: (filterDateValue: Date | null) => void;
}

const FilterBox: React.FC<IProps> = ({ toggle, handleFiltering }) => {
  const [filterDateValue, setFilterDateValue] = React.useState<Date | null>(
    new Date()
  );

  const handleDateFilterChange = (newValue: Date | null) => {
    setFilterDateValue(newValue);
  };

  /*   const initialValues = { filterValue };

  const onSubmit = (values: { filterValue: string }) => {
    setFilterValue(values.filterValue);
    toggle();
  }; */

  return (
    <div className={styles.filter_wrapper}>
      {/*       <Formik initialValues={initialValues} onSubmit={onSubmit}>
        <Form> */}
      {/* <Field name='filterValue' type='text' placeholder='Filter' /> */}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Stack spacing={3}>
          <DatePicker
            disableFuture
            label="Filter By Date"
            inputFormat="MM/dd/yyyy"
            value={filterDateValue}
            onChange={handleDateFilterChange}
            renderInput={(params) => <TextField {...params} />}
          />
          <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            onClick={() => handleFiltering(filterDateValue)}
          >
            Filter
          </Button>
        </Stack>
      </LocalizationProvider>
      {/*           <button type="submit">
            <DoneAllIcon />
          </button>
        </Form>
      </Formik> */}
    </div>
  );
};

export default FilterBox;
